import React from 'react'

import { useSelector } from 'react-redux'

import { TemplatesPDF } from '@interco/cp-react-ui-lib'
import { ApplicationState } from '@store/types'
import { StepRefin } from '@utils/enums'
import { useTrackingRefin } from '@hooks'
import { Header } from '@atoms'

import { PageVisualizarPdf, PdfGrid } from './styles'

interface BulletItem {
  text: string
  subItems?: string[]
}

const autorizacaoCtpsBulletItems: BulletItem[] = [
  { text: 'CPF' },
  { text: 'Matrícula' },
  { text: 'Inscrição do Empregador (Código e Descrição)' },
  { text: 'Número da Inscrição do Empregador' },
  { text: 'Nome' },
  { text: 'Sexo (Código e Descrição)' },
  { text: 'Data de Nascimento' },
  { text: 'Código da Categoria do Trabalhador' },
  { text: 'Elegibilidade (Sim/Não)' },
  { text: 'Valor Total dos Vencimentos' },
  { text: 'Valor Base da Margem' },
  { text: 'Valor da Margem Disponível' },
  { text: 'Data de Admissão' },
  { text: 'Data de Desligamento' },
  { text: 'Código do Motivo do Desligamento' },
  { text: 'Pessoa Exposta Politicamente (Código e Descrição)' },
  { text: 'Quantidade de empréstimos ativos ou suspensos' },
  { text: 'Alertas de Afastamento e Aviso Prévio' },
  {
    text: 'Informações sobre empréstimos existentes que foram informados previamente pelas instituições financeiras, quais sejam:',
    subItems: [
      'Empréstimo com descontos em folha de pagamento, com parcelas vincendas.',
      'Empréstimo não consignado, sem garantia (créditos pessoais, também chamados empréstimos pessoais), com parcelas vincendas.',
    ],
  },
]

const Autorizacao = () => {
  const { userNameDadosPessoais, cpfDadosPessoais } = useSelector(
    (state: ApplicationState) => state.refinanciamento.dadosPessoais,
  )
  const { userNameSession, cpfSession } = useSelector((state: ApplicationState) => state.session)
  const { userNameAuthentication, cpfAuthentication } = useSelector(
    (state: ApplicationState) => state.refinanciamento.authentication,
  )
  const { isApp } = useSelector((state: ApplicationState) => state.ui.navigation)
  const { convenioName } = useSelector((state: ApplicationState) => state.refinanciamento.contratos)

  const variant = 'web' as const
  const nomePessoa = userNameAuthentication ?? userNameDadosPessoais ?? userNameSession ?? ''
  const cpfPessoa = cpfAuthentication ?? cpfDadosPessoais ?? cpfSession ?? ''

  useTrackingRefin(StepRefin.LEITURA_DOCUMENTACAO_AUTORIZACAO)

  return (
    <>
      {isApp ? <Header showLeftIcon>Termo de autorização {convenioName}</Header> : <></>}
      <PageVisualizarPdf id="autorizacao-consulta-ctps" isApp hasProgressStep={false}>
        <PdfGrid>
          <TemplatesPDF.PageDeclaracaoAutorizacaoCTPS
            variant={variant}
            pessoa={{
              nome: nomePessoa,
              cpf: cpfPessoa,
            }}
            bulletItems={autorizacaoCtpsBulletItems}
            assinatura={{
              isDgAssinado: false,
              cidade: 'Belo Horizonte',
              data: new Date(),
            }}
            footer={{
              atualizado: new Date(),
              codigo: 'CP103',
              edicao: '1.1',
            }}
          />
        </PdfGrid>
      </PageVisualizarPdf>
    </>
  )
}

export default Autorizacao
